export default __webpack_public_path__ + "fonts/498042b7fe9cd07b4fd11a0965093e55.woff";